export default function Input({className, password, hidden, number, url, multiLine, ...props})
{
  const Tag = multiLine ? 'textarea' : 'input';
  return <Tag
    className={`border-b-2 border-primary-light bg-transparent ${props.readOnly ? 'border-dotted text-gray-600' : 'focus:border-primary'} outline-none ${className}`}
    type={password ? 'password' : hidden ? 'hidden' : number ? 'number' : url ? 'url' : 'text'}
    {...props} />;
}
